import React from "react"
import { LinkButton } from "./LinkButton"
import { icons } from "../../constants/icons"
import { IComponentProps } from "@cd2/components/build/es6/types/utils"
import { useDownload } from "../DownloadFileButton"

export function DownloadLinkButton(
  props: IComponentProps<typeof LinkButton> & { iconSide?: "left" | "right" },
) {
  const download = useDownload()
  const icon =
    props.iconSide == "right" ? { rightIcon: icons.download } : { leftIcon: icons.download }
  return (
    <LinkButton
      {...icon}
      buttonColor="white"
      external
      {...props}
      to={undefined}
      onClick={props.onClick ? props.onClick : props.to ? () => download(props.to!) : undefined}
    />
  )
}
